import React from 'react'
import cl from 'classnames'
import styles from './styles.module.scss'

interface Props {
  orientation?: 'vertical' | 'horizontal'
  type?: 'primary' | 'secondary'
  className?: string
}

export const Divider = ({
  orientation = 'horizontal',
  type = 'primary',
  className
}: Props) => {
  return (
    <div
      className={cl(styles.root, styles[orientation], styles[type], className)}
    />
  )
}
